import React from 'react';

import { EmployeeAvatar } from '@modernloop/shared/components';
import { Chip, SxProps, Theme } from '@mui/material';

import { BaseProps } from 'src/components/types';

type Props = BaseProps & {
  name: string;
  photoSrc: string | undefined;
  variant: 'filled' | 'outlined';
  sx?: SxProps<Theme>;
};

/**
 * Helper component to display an employee chip from a photo url
 */
const EmployeeChip: React.FC<Props> = ({ sx, name, photoSrc, variant, dataTestId }) => {
  return (
    <Chip
      sx={{
        // Match the font size of the assignee selector (body1)
        '& .MuiChip-label': {
          fontSize: (theme) => theme.typography.body1.fontSize,
        },
        ...sx,
      }}
      label={name}
      variant={variant}
      data-testid={dataTestId}
      avatar={<EmployeeAvatar imageUrl={photoSrc} fullName={name} size={20} />}
    />
  );
};

export default EmployeeChip;
